import { appViewState } from "../store";
import { LoginState } from "../store/schema/LoginViewState";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setLoginState", function setLoginState(
    state: LoginState
) {
    appViewState().loginViewState.loginState = state;
});